// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingInfoStyles } from "@bg/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitShippingInfo";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

shippingInfoStyles.clickableLinkStyles = {
    css: css`
        color: ${getColor("text.main")};

        &,
        span {
            font-size: ${fontConfig.fontSize.xSmall}px;
            line-height: ${fontConfig.lineHeight.singleLineSmall};
        }

        &:hover,
        &:focus {
            text-decoration: underline;
        }
    `,
};
shippingInfoStyles.editIconStyles = {
    size: 14,
    color: "tertiary",
    css: css`
        fill: ${getColor("tertiary")};
        margin-right: 3px;
    `,
};
